export type ApplyStepName =
  | 'homepage'
  | 'auth'
  | 'personal_information'
  | 'personal_traits'
  | 'required_documents'
  | 'contact_information'
  | 'mailing_address'
  | 'history'
  | 'locations'
  | 'payment'
  | 'book_appt'
  | 'confirmation'

export type RenewStepName =
  | 'homepage'
  | 'auth'
  | 'personal_information'
  | 'eligibility_histroy'
  | 'eligibility_results'
  | 'contact'
  | 'address'
  | 'payment'
  | 'confirmation'

export function trackFunnelStep(
  flowType: 'apply',
  stepNumber: number,
  stepName: ApplyStepName
): void

export function trackFunnelStep(
  flowType: 'renew',
  stepNumber: number,
  stepName: RenewStepName
): void

export function trackFunnelStep(
  flowType: 'apply' | 'renew',
  stepNumber: number,
  stepName: ApplyStepName | RenewStepName
): void {
  if (typeof window === 'undefined') {
    console.warn('gtag not available')
    return
  }
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'funnel_step',
    flow_type: flowType,
    step_number: stepNumber,
    step_name: stepName,
  })
}
